<template>
  <v-card flat dense>
    <v-card-text>
      <v-layout class="row wrap">
        <v-flex xs12 class="beez-padding">
          <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
            <v-flex pa-2 ma-2>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg4>
                      <div class="text-xs-left">
                        <br />
                        <div>Package Id</div>
                        <div class="subheading">
                          {{ aPackage.hexId }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 lg4>
                      <div class="text-xs-left">
                        <br />
                        <div>Unique reference number</div>
                        <div class="subheading">
                          {{ aPackage.packageManifestModel.packageId }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 lg4>
                      <div class="text-xs-left">
                        <br />
                        <div>Status</div>
                        <div
                          :class="
                            aPackage.packageStatus === 'FAILED'
                              ? 'red--text subheading font-weight-bold'
                              : aPackage.packageStatus === 'SUCCESSFUL'
                              ? 'green--text subheading font-weight-bold'
                              : 'blue--text subheading font-weight-bold'
                          "
                        >
                          {{ changeCase(aPackage.packageStatus) }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 lg4>
                      <div class="text-xs-left">
                        <br />
                        <div>Package Type</div>
                        <div class="subheading">
                          {{ changeCase(aPackage.packageType) }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                    <v-flex xs12>
                      <v-card flat xs12 style="border-radius: 5px" class="mt-2">
                        <v-toolbar flat dense>
                          <v-toolbar-title class="body-2"
                            >Package contents</v-toolbar-title
                          >
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="!isExpanded"
                            @click="expandAll"
                            flat
                            icon
                          >
                            <v-icon medium>
                              expand_more
                            </v-icon>
                          </v-btn>
                          <v-btn v-else @click="collapseAll" flat icon>
                            <v-icon medium>
                              expand_less
                            </v-icon>
                          </v-btn>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              v-if="
                                inboundPackages && can('CHECK_INBOUND_PACKAGE')
                              "
                              :loading="checkLoader"
                              @click="checkPackage"
                              flat
                              icon
                            >
                              <v-icon medium>
                                check_circle
                              </v-icon>
                            </v-btn>
                            <span>Check Package Contents</span>
                          </v-tooltip>
                        </v-toolbar>
                        <v-card-text>
                          <v-progress-linear
                            v-if="checkLoader"
                            indeterminate
                            color="primary"
                          ></v-progress-linear>
                          <v-treeview
                            :items="items"
                            :search="query"
                            :open="activeItems"
                            transition
                            open-all
                          >
                            <template
                              v-if="!item.children"
                              slot="prepend"
                              slot-scope="{ item }"
                            >
                              <v-icon>account_circle</v-icon>
                            </template>
                            <template slot="label" slot-scope="{ item }">
                              <div style="cursor:pointer;" class="text-xs-left">
                                <v-card
                                  max-width="600px"
                                  :class="
                                    $vuetify.dark
                                      ? 'card-dark pa-2 ma-2'
                                      : 'card-light pa-2 ma-2'
                                  "
                                  style="border-radius: 5px"
                                >
                                  <v-layout
                                    row
                                    wrap
                                    align-center
                                    justify-space-between
                                    fill-height
                                  >
                                    <v-flex xs1>
                                      <v-icon class="grey--text">
                                        {{
                                          item.type === 'Bot Template'
                                            ? 'library_books'
                                            : item.type === 'Bot'
                                            ? 'adb'
                                            : item.type === 'Workflow'
                                            ? 'account_tree'
                                            : item.type ===
                                              'Automation Services'
                                            ? 'laptop_chromebook'
                                            : item.type === 'Rules'
                                            ? 'gavel'
                                            : item.type === 'Task Forms'
                                            ? 'web'
                                            : item.type === 'Email Template'
                                            ? 'mail'
                                            : item.type === 'Honey Roles'
                                            ? 'admin_panel_settings'
                                            : 'check'
                                        }}
                                      </v-icon>
                                    </v-flex>
                                    <v-flex xs4>
                                      <div class="body-1 font-weight-bold">
                                        {{ item.type }}
                                      </div>
                                    </v-flex>
                                    <v-flex xs5>
                                      <div class="body-1 font-weight-bold">
                                        {{ item.name }}
                                      </div>
                                      <div class="caption">
                                        {{ item.hexId }}
                                      </div>
                                    </v-flex>
                                    <v-flex xs1>
                                      <v-tooltip bottom>
                                        <v-icon
                                          slot="activator"
                                          v-if="item.status === 'FAILED'"
                                          class="red--text"
                                          >dangerous
                                        </v-icon>
                                        <span>Error in deployment</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <v-icon
                                          slot="activator"
                                          v-if="item.status === 'SUCCESSFUL'"
                                          class="green--text"
                                          >check_circle
                                        </v-icon>
                                        <span>Successfully deployed</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <v-icon
                                          slot="activator"
                                          v-if="item.status === 'OPEN'"
                                          class="grey--text"
                                          >remove_circle
                                        </v-icon>
                                        <span>Yet to be deployed</span>
                                      </v-tooltip>
                                    </v-flex>
                                    <v-flex xs1>
                                      <v-tooltip bottom>
                                        <v-icon
                                          slot="activator"
                                          v-if="item.actionType === 'NEW'"
                                          class="blue--text"
                                          >add_circle
                                        </v-icon>
                                        <span>New object</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <v-icon
                                          slot="activator"
                                          v-if="item.actionType === 'UPGRADE'"
                                          class="blue--text"
                                          >update
                                        </v-icon>
                                        <span
                                          >Update over and existing object</span
                                        >
                                      </v-tooltip>
                                    </v-flex>
                                  </v-layout>
                                </v-card>
                              </div>
                            </template>
                          </v-treeview>
                        </v-card-text>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 v-if="inboundPackages" class="mt-4">
                      <v-card
                        flat
                        xs12
                        :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                        style="border-radius: 5px"
                      >
                        <v-toolbar flat dense>
                          <v-toolbar-title class="body-2"
                            >Package deployment logs</v-toolbar-title
                          >
                          <v-btn
                            flat
                            icon
                            @click="showPackageLogs = !showPackageLogs"
                          >
                            <v-icon
                              >{{
                                showPackageLogs ? 'expand_less' : 'expand_more'
                              }}
                            </v-icon>
                          </v-btn>
                        </v-toolbar>
                        <div v-if="showPackageLogs">
                          <v-data-table
                            :headers="headers"
                            :items="tableItems"
                            :total-items="pagination.totalItems"
                            :pagination.sync="pagination"
                            item-key="hexId"
                            :loading="packageDeploymentLoader"
                            :rows-per-page-items="headerPageItems"
                          >
                            <v-progress-linear
                              slot="progress"
                              color="accent"
                              indeterminate
                            />
                            <template slot="items" slot-scope="props">
                              <td class="text-xs-left">
                                <div class="body-1 font-weight-bold">
                                  {{
                                    changeCase(props.item.packageContentType)
                                  }}
                                </div>
                              </td>
                              <td class="text-xs-left">
                                <div
                                  :class="
                                    props.item.packageDeploymentStatus ===
                                    'FAILED'
                                      ? 'red--text'
                                      : props.item.packageDeploymentStatus ===
                                        'SUCCESSFUL'
                                      ? 'green--text'
                                      : 'blue--text'
                                  "
                                >
                                  <div class="body-1 font-weight-bold">
                                    {{
                                      changeCase(
                                        props.item.packageDeploymentStatus
                                      )
                                    }}
                                  </div>
                                </div>
                              </td>
                              <td class="text-xs-left">
                                <div class="body-1 font-weight-bold">
                                  <v-tooltip bottom>
                                    <v-btn
                                      slot="activator"
                                      icon
                                      flat
                                      class="text-xs-center"
                                      :ripple="false"
                                      v-if="
                                        props.item.packageActionType === 'NEW'
                                      "
                                    >
                                      <v-icon class="blue--text"
                                        >add_circle
                                      </v-icon>
                                    </v-btn>
                                    <span>New object</span>
                                  </v-tooltip>
                                  <v-tooltip bottom>
                                    <v-btn
                                      slot="activator"
                                      icon
                                      flat
                                      class="text-xs-center"
                                      :ripple="false"
                                      v-if="
                                        props.item.packageActionType ===
                                          'UPGRADE'
                                      "
                                    >
                                      <v-icon class="blue--text">update</v-icon>
                                    </v-btn>
                                    <span>Update over and existing object</span>
                                  </v-tooltip>
                                </div>
                              </td>
                              <td class="text-xs-left">
                                <div class="body-1 font-weight-bold">
                                  {{ props.item.sourceId }}
                                </div>
                              </td>
                              <td class="text-xs-left">
                                <div class="body-1 font-weight-bold">
                                  {{ props.item.destinationId }}
                                  <v-tooltip
                                    bottom
                                    v-if="props.item.destinationId"
                                  >
                                    <v-btn
                                      v-if="props.item.destinationId"
                                      slot="activator"
                                      icon
                                      flat
                                      small
                                      :to="{
                                        name:
                                          props.item.packageContentType ===
                                          'BOT_TEMPLATE'
                                            ? 'bot-template-detail'
                                            : props.item.packageContentType ===
                                              'BOT'
                                            ? 'bot-detail'
                                            : props.item.packageContentType ===
                                              'WORKFLOW'
                                            ? 'workflow-detail'
                                            : props.item.packageContentType ===
                                              'AUTOMATION_SERVICES'
                                            ? 'self-service-detail'
                                            : props.item.packageContentType ===
                                              'RULES'
                                            ? 'rule-detail'
                                            : props.item.packageContentType ===
                                              'TASK_FORMS'
                                            ? 'honey-form-detail'
                                            : props.item.packageContentType ===
                                              'EMAIL_TEMPLATE'
                                            ? 'email-template-detail'
                                            : props.item.packageContentType ===
                                              'HONEY_ROLES'
                                            ? 'role-maintenance'
                                            : 'home',
                                        params: {
                                          hexId: props.item.destinationId
                                        }
                                      }"
                                    >
                                      <v-icon class="blue--text">link</v-icon>
                                    </v-btn>
                                    <span>Quick Link</span>
                                  </v-tooltip>
                                </div>
                              </td>
                              <td class="text-xs-left">
                                <div class="body-1 font-weight-bold">
                                  {{ props.item.deployedByLocal }}
                                </div>
                              </td>
                              <td class="text-xs-left">
                                <div class="body-1 font-weight-bold">
                                  {{ props.item.deploymentEndedAtLocal }}
                                </div>
                              </td>
                              <td class="text-xs-left">
                                <div class="body-1 font-weight-bold">
                                  {{ props.item.message }}
                                </div>
                              </td>
                            </template>
                            <template slot="no-data">
                              <v-alert
                                :value="true"
                                color="warning"
                                icon="warning"
                              >
                                No Deployment logs found!
                              </v-alert>
                            </template>
                          </v-data-table>
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'PackageDetail',
  props: {
    aPackage: Object,
    checkResult: Array,
    checkLoader: Boolean,
    inboundPackages: Boolean
  },
  data() {
    return {
      packageDeploymentLoader: false,
      isExpanded: false,
      activeItems: [],
      showPackageLogs: false,
      items: [],
      tableItems: [],
      query: '',
      count: 0,
      pagination: {
        sortBy: 'changedAt',
        rowsPerPage: 10,
        descending: true,
        totalItems: 0,
        page: 1
      },
      headerPageItems: [5, 10, 25],
      headers: [
        {
          text: 'Content Type',
          value: 'packageContentType'
        },
        { text: 'Deployment status', value: 'packageDeploymentStatus' },
        { text: 'Deployment action', value: 'packageActionType' },
        { text: 'Source reference Id', value: 'sourceId' },
        { text: 'Created/Updated Object Id', value: 'destinationId' },
        { text: 'Deploy By', value: 'deployedBy' },
        { text: 'Deployed At', value: 'changedAt' },
        { text: 'Message', value: 'message' }
      ]
    }
  },
  computed: {
    ...mapState({
      honeyUsers: state => state.honeyUsers.honeyUsers,
      packageDeployments: state => state.packages.packageDeployments,
      totalPackageDeployments: state => state.packages.packageDeploymentCount
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  mounted() {
    this.tableItems = []
    this.items = []
    this.fillItems()
    this.refresh()
  },
  watch: {
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.currentPage ||
            this.pagination.rowsPerPage !== this.rowsPerPage ||
            this.pagination.sortBy !== this.sortBy ||
            this.pagination.descending !== this.descending
          ) {
            this.currentPage = this.pagination.page
            this.rowsPerPage = this.pagination.rowsPerPage
            this.sortBy = this.pagination.sortBy
            this.descending = this.pagination.descending
            this.refresh()
          }
        } catch (error) {}
      },
      deep: true
    },
    totalPackageDeployments() {
      this.pagination.totalItems = this.totalPackageDeployments
    },
    aPackage: {
      handler() {
        this.tableItems = []
        this.items = []
        this.fillItems()
        this.refresh()
      },
      deep: true
    },
    checkResult() {
      this.fillItems()
    },
    packageDeployments() {
      this.fillTableItem()
    }
  },
  methods: {
    collapseAll() {
      this.activeItems = []
      this.isExpanded = false
    },
    expandAll() {
      let i = 0
      while (i <= this.count) {
        this.activeItems.push(i)
        i++
      }
      this.isExpanded = true
    },
    checkPackage() {
      this.$emit('checkPackage')
    },
    changeCase(str) {
      return _.startCase(_.lowerCase(str))
    },

    fillItems() {
      this.items = []
      this.count = 0
      this.aPackage.packageManifestModel.contents.forEach(i => {
        this.items.push(this.createItem(i))
      })
    },
    fillTableItem() {
      let logList = _.clone(this.packageDeployments)
      this.tableItems = []
      this.tableItems = logList.map(e => {
        try {
          e.deployedByLocal = this.honeyUsers.find(
            user => user.hexId === e.createdBy
          ).username

          e.deploymentStatedAtLocal = moment(e.createdAt)
            .utc()
            .local()
            .format('DD MMM YYYY hh:mm:ss a')
          e.deploymentEndedAtLocal = moment(e.changedAt)
            .utc()
            .local()
            .format('DD MMM YYYY hh:mm:ss a')

          // eslint-disable-next-line no-empty
        } catch (ex) {}
        return e
      })
    },
    createItem(i) {
      let item = {}
      item.id = this.count
      this.count++
      if (this.checkResult && this.checkResult.length > 0) {
        let logModel = this.checkResult.find(j => j.sourceId === i.hexId)
        item.actionType = logModel && logModel.packageActionType
        item.status = (logModel && logModel.packageDeploymentStatus) || 'OPEN'
      }

      item.name = _.isUndefined(i.contentMetaData.name)
        ? i.contentMetaData.formKey
        : i.contentMetaData.name

      item.type = this.changeCase(i.contentType)
      item.hexId = i.hexId
      item.children = []
      i.dependencies.forEach(j => {
        item.children.push(this.createItem(j))
      })
      return item
    },
    async refresh() {
      this.packageDeploymentLoader = true
      let urlParams = ''
      urlParams = `page=${this.pagination.page}`
      if (this.pagination.rowsPerPage !== -1) {
        urlParams =
          urlParams +
          `&size=${this.pagination.rowsPerPage}&sort=${this.pagination.sortBy}${
            this.pagination.descending ? ',desc' : ''
          }`
      }
      let data = {}
      data.urlParams = urlParams
      data.id = this.aPackage.hexId
      try {
        await this.$store.dispatch('fetchPackageDeployments', data)
        await this.$store.dispatch(
          'fetchPackageDeploymentCount',
          this.aPackage.hexId
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Error in getting package deployments',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.packageDeploymentLoader = false
    }
  }
}
</script>

<style scoped></style>
